import { createSvgIcon } from '@mui/material/utils'

const ArrowLeftCircle = createSvgIcon(
  <>
    <circle
      cx="19.461"
      cy="18.7865"
      r="18.1387"
      fill="white"
      stroke="#D8D9DC"
      strokeWidth="1.29562"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2274 18.9006L22.0012 11.1268L21.085 10.2107L13.3113 17.9844L12.3951 18.9006L12.3951 18.9006L13.3113 19.8167L21.085 27.5905L22.0011 26.6743L14.2274 18.9006Z"
      fill="#262D3D"
    />
  </>,
  'ArrowLeftCircle'
)

export default ArrowLeftCircle
